import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import apiServices from "../../services/apiServices";
import moment from 'moment'
// First, create the thunk
export const fetchAllSales = createAsyncThunk(
  "sales_state/fetchAllStatus",
  async () => {
    const response = await apiServices.get("sales");
    console.log(response.data.data);
    return response.data.data;
  }
);
export const fetchAllSalesByCustomerID = createAsyncThunk(
  "sales_state/fetchAllSalesByCustomerID",
  async (id) => {
    const response = await apiServices.get("sales/customer/"+id);
    console.log(response.data.data);
    return response.data.data;
  }
);
export const updateSales = createAsyncThunk(
  "sales_state/updateSales",
  async (data) => {
    console.log("sales_state/updateSales", data);
    const response = await apiServices.put("sales/" + data.id, data);
    console.log(response.data.data);
    console.log(response.data.message);
    return response.data.data;
  }
);
export const sendInvoice = createAsyncThunk(
  "sales_state/sendInvoice",
  async (emailPdf, invoiceCustomer) => {
    console.log("sales_state/sendInvoice", emailPdf);
    let formData = new FormData();     
formData.append("invoiceFile", emailPdf);
    const response = await apiServices.post("sendInvoice", {});
    console.log(response.data);
    
    return response.data;
  }
);
export const addSales = createAsyncThunk(
  "sales_state/addSales",
  async (data, thunkAPI) => {

    try{

      const response = await apiServices.post("sales", data);
      console.log(response.data.data);
      return response.data.data;
    }catch(ex){

      console.log("add error", ex)
      console.log("add new sale error", ex.response.data)
      return thunkAPI.rejectWithValue(ex.response)
    }
  }
);
export const updateInvoiceStatus = createAsyncThunk(
  "sales_state/updateInvoiceStatus",
  async (data, thunkAPI) => {

    try{

      const response = await apiServices.put("sales/status/"+data.id, data);
      console.log(response.data.data);
      return response.data.data;
    }catch(ex){

      console.log("updateInvoiceStatus", ex)
     
      return thunkAPI.rejectWithValue(ex)
    }
  }
);

const initialState = {
  sales: [],
  invoice: {
    invoiceItemList:[]
  },
  EditInvoice: {
    invoiceItemList:[],
    invoiceCreatedDate:null
  },
  recentInvoice: {},
  error: "",
  salesListByCustomerId:[]
};

let salesSlice = createSlice({
  name: "sales_state",
  initialState,
  reducers: {
    // insert actions here

    //action 2
    clearInvoice: function (state, action) {
      // api call for the fetch all sales from server
       
       
      state.invoice = {
        id :null ,  
        invoiceNumber :null ,  
        invoiceCreatedDate :null ,  
        invoiceType :null ,  
        invoiceCategory :null ,  
        invoiceSubCategory :null ,  
        invoiceCurrency :null , 
        invoiceShipmentStatus :null ,  
        invoicePaymentType :null ,  
        invoiceStatus :null ,  
        invoiceCustomer :null , 
        invoiceBanks :null ,  
        invoiceSubTotal :null ,  
        invoiceDiscountAmount :null , 
        invoiceSubTotalAfterDiscount :null ,  
        invoiceGrandTotal :null ,  
        invoiceExtraCharges :null ,  
        invoiceTotalAmountReceived :null , 
        invoiceBalanceToReceived :null , 
        invoiceBalanceToCustomer :null ,  
        invoiceDate :null ,  
        invoiceItemList :null ,  
        invoiceBroker :null ,  
      }
      console.log("invoice cleared", initialState.invoice)
    },
    clearEditInvoice: function (state, action) {
      // api call for the fetch all sales from server
       
      state.EditInvoice = {
        id :null ,  
        invoiceNumber :null ,  
        invoiceCreatedDate :null ,  
        invoiceType :null ,  
        invoiceCategory :null ,  
        invoiceSubCategory :null ,  
        invoiceCurrency :null , 
        invoiceShipmentStatus :null ,  
        invoicePaymentType :null ,  
        invoiceStatus :null ,  
        invoiceCustomer :null , 
        invoiceBanks :null ,  
        invoiceSubTotal :null ,  
        invoiceDiscountAmount :null , 
        invoiceSubTotalAfterDiscount :null ,  
        invoiceGrandTotal :null ,  
        invoiceExtraCharges :null ,  
        invoiceTotalAmountReceived :null , 
        invoiceBalanceToReceived :null , 
        invoiceBalanceToCustomer :null ,  
        invoiceDate :null ,  
        invoiceItemList :null ,  
        invoiceBroker :null ,  
      }
      console.log("edited invoice cleared", initialState.invoice)
    },
    //action 2
    removeAllItemFromCart: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      state.invoice.invoiceItemList = [];
    },
    removeAllItemFromCartEditedInvoice: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      state.EditInvoice.invoiceItemList = [];
    },
    addToCart: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      state.invoice.invoiceItemList = payload;
    },
    addToCartEditedInvoice: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      state.EditInvoice.invoiceItemList = payload;
    },

    addCartItemDiscount: function (state, action) {
      console.log("action.payload.customer", action.payload);
      const { discount, index } = action.payload;
      state.invoice.invoiceItemList[index].itemDiscountAmount =
        parseFloat(discount);
    },
    addCartEditedInvoiceItemDiscount: function (state, action) {
      console.log("action.payload.customer", action.payload);
      const { discount, index } = action.payload;
      state.EditInvoice.invoiceItemList[index].itemDiscountAmount =
        parseFloat(discount);
    },
    addInvoiceCustomer: function (state, action) {
      console.log("action.payload.customer", action.payload);
      state.invoice.invoiceCustomer = action.payload;
    },
    addSummary: function (state, action) {
      let { payload } = action;

      state.invoice.foreignInvoice = payload.foreignInvoice;
      state.invoice.invoiceType = payload.invoiceType; //sales // on-approval
      state.invoice.invoicePaymentType = payload.invoicePaymentType; //cash // cheque
      state.invoice.invoiceFullPaid = payload.invoiceFullPaid; //true or false
      state.invoice.invoiceStatus = payload.invoiceStatus; // active  //return //cancel
      state.invoice.invoiceForeignTotalAmount =
        payload.invoiceForeignTotalAmount;
      state.invoice.invoiceTotalAmount = payload.invoiceTotalAmount; //total amount before discount
      state.invoice.invoiceTotalDiscountAmount =
        payload.invoiceTotalDiscountAmount; //sum of discounts
      state.invoice.invoiceAdvanceAmount = payload.invoiceAdvanceAmount;
      state.invoice.invoicePaidAmount = payload.invoicePaidAmount; //paid amount
      state.invoice.invoicePayableTotal = payload.invoicePayableTotal; // invoicePayableTotal = invoiceTotalAmount - (invoiceTotalDiscountAmount + invoiceAdvanceAmount )
      state.invoice.invoiceBalanceAmount = payload.invoiceBalanceAmount; // invoiceBalanceAmount = invoicePayableTotal - invoicePaidAmount
      let invoDate = new Date();
      const invoice = {
        foreignInvoice: payload.foreignInvoice,
        invoiceType: payload.invoiceType,
        invoicePaymentType: payload.invoicePaymentType, //cash // cheque
        invoicePaidType:
          payload.invoiceBalanceAmount === 0 ? "full" : "partial", //full // partial // installment
        invoiceDate:
          invoDate.getDate() +
          "/" +
          (invoDate.getMonth() + 1) +
          "/" +
          invoDate.getFullYear(),
        invoiceNumber: "",
        invoiceCreatedBy: "",

        invoiceStatus: "active",
        invoiceCustomer: state.invoice.invoiceCustomer,
        invoiceItemList: state.invoice.invoiceItemList,

        invoiceForeignTotalAmount: payload.invoiceForeignTotalAmount,
        invoicePaidAmount: payload.invoicePaidAmount,
        invoiceTotalAmount: payload.invoiceTotalAmount,
        invoiceTotalDiscountAmount: payload.invoiceTotalDiscountAmount,
        invoiceAdvanceAmount: payload.invoiceAdvanceAmount,
        invoiceBalanceAmount: payload.invoiceBalanceAmount,
        invoicePayableTotal: payload.invoicePayableTotal,
      };
      // state.sales.push(invoice);

      // state.recentInvoice = invoice
      //state.invoice = initialState.invoice
    },

    fullPaid: function (state, action) {
      state.invoice.invoicePaidType = "full";
      state.invoice.invoiceFullPaid = true;
      state.invoice.invoiceStatus = "active";

      state.invoiceAdvanceAmount = 0.0;
      state.invoiceBalanceAmount = 0.0;
      state.invoicePayableTotal = action.payload.invoicePayableTotal;
      state.invoice.invoicePaidAmount = action.payload.invoicePaidAmount;
    },
    calculateTotalPrice: function (state, action) {
      let totalInvoiceAmount = 0.0;
      let totalForeignInvoiceAmount = 0.0;

      for (let x of state.invoice.invoiceItemList) {
        totalForeignInvoiceAmount += Number(x.sellPriceForeigners);
        totalInvoiceAmount += Number(x.sellPriceLocal);
        console.log(totalInvoiceAmount.toFixed(2));
      }

      state.invoice.invoiceTotalAmount = totalInvoiceAmount.toFixed(2);
      state.invoice.invoiceForeignTotalAmount =
        totalForeignInvoiceAmount.toFixed(2);
    },
    removeItemFromCart: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      console.log("index", payload)
      console.log("before removed", state.invoice.invoiceItemList)
      var filtered = state.invoice.invoiceItemList.filter(function (
        value,
        index,
        arr
      ) {
        return index !== payload;
      });
      console.log("after removed", filtered )
      state.invoice.invoiceItemList = filtered;
    },
    removeItemFromEditCart: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      var filtered = state.EditInvoice.invoiceItemList.filter(function (
        value,
        index,
        arr
      ) {
        return index !== payload;
      });
      console.log("Edit Invoice , removing item from cart index is : ", payload , filtered)
      state.EditInvoice.invoiceItemList = filtered;
    },
    addTotalInvoiceAmount: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      state.invoice.invoiceTotalAmount = payload;
    },
    addInvoiceType: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.invoice.foreignInvoice = payload.foreignInvoice;
      state.invoice.invoiceType = payload.invoiceType;

      console.log(state.sales);
    },
    addNewSales: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      state.sales = [...state.sales, payload];

      console.log(state.sales);
    },
  

    addEditedSalesToLocal: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      let invoiceItemList = state.EditInvoice.invoiceItemList 
      state.EditInvoice =  payload 
      state.EditInvoice.invoiceItemList = invoiceItemList


      console.log("EditInvoice saved in Local");
    },
     addNewSalestoLocal: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;
      console.log("payload", payload);

      //return new state
      let invoiceItemList = state.invoice.invoiceItemList 
      state.invoice =  payload 
      state.invoice.invoiceItemList = invoiceItemList


      console.log("invoice saved in Local");
    },
    addEditedInvoice: function (state, action) {
      // api call for the fetch all sales from server
      let { payload } = action;  
      console.log("payload.invoiceCreatedDate", payload)
      console.log(moment(payload.invoiceCreatedDate).format('DD/MM/YYYY'))
      state.EditInvoice =  payload  
      // state.EditInvoice['invoiceCreatedDate'] = moment(payload.invoiceCreatedDate).format('MM/DD/YYYY')
      console.log("clicked EditInvoice ");
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllSales.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllSales.fulfilled, (state, action) => {
      // Add user to the state array

      let sales = [];
      action.payload.map((x) => {
        let sale = {
          id: x._id,
          invoiceNumber:x.invoiceNumber,
          invoiceCreatedDate:x.invoiceCreatedDate,
          invoiceType:x.invoiceType,
          invoiceCategory:x.invoiceCategory,
          invoiceSubCategory:x.invoiceSubCategory,
          invoiceCurrency:x.invoiceCurrency,
          invoiceShipmentStatus:x.invoiceShipmentStatus,
          invoicePaymentType:x.invoicePaymentType,
          invoiceStatus:x.invoiceStatus,
          invoiceCustomer:x.invoiceCustomer,
          invoiceBanks:x.invoiceBanks,
          invoiceSubTotal:x.invoiceSubTotal,
          invoiceDiscountAmount:x.invoiceDiscountAmount,
          invoiceSubTotalAfterDiscount:x.invoiceSubTotalAfterDiscount,
          invoiceGrandTotal:x.invoiceGrandTotal,
          invoiceExtraCharges:x.invoiceExtraCharges || 0,
          invoiceTotalAmountReceived:x.invoiceTotalAmountReceived || 0,
          invoiceBalanceToReceived:x.invoiceBalanceToReceived || 0 ,
          invoiceBalanceToCustomer:x.invoiceBalanceToCustomer || 0,
          invoiceDate:x.invoiceDate,
          invoiceItemList:x.invoiceItemList,
          invoiceBroker:x.invoiceBroker,
          
        };

        return sales.push(sale);
      });
      console.log("sales : ", action.payload);
      state.sales = sales;
      state.loading = false;
    });
    builder.addCase(fetchAllSales.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetching sales";
    });
    builder.addCase(fetchAllSalesByCustomerID.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllSalesByCustomerID.fulfilled, (state, action) => {
      // Add user to the state array

      let sales = [];
      action.payload.map((x) => {
        let sale = {
          id: x._id,
          invoiceNumber:x.invoiceNumber,
          invoiceCreatedDate:x.invoiceCreatedDate,
          invoiceType:x.invoiceType,
          invoiceCategory:x.invoiceCategory,
          invoiceSubCategory:x.invoiceSubCategory,
          invoiceCurrency:x.invoiceCurrency,
          invoiceShipmentStatus:x.invoiceShipmentStatus,
          invoicePaymentType:x.invoicePaymentType,
          invoiceStatus:x.invoiceStatus,
          invoiceCustomer:x.invoiceCustomer,
          invoiceBanks:x.invoiceBanks,
          invoiceSubTotal:x.invoiceSubTotal,
          invoiceDiscountAmount:x.invoiceDiscountAmount,
          invoiceSubTotalAfterDiscount:x.invoiceSubTotalAfterDiscount,
          invoiceGrandTotal:x.invoiceGrandTotal,
          invoiceExtraCharges:x.invoiceExtraCharges || 0,
          invoiceTotalAmountReceived:x.invoiceTotalAmountReceived || 0,
          invoiceBalanceToReceived:x.invoiceBalanceToReceived || 0 ,
          invoiceBalanceToCustomer:x.invoiceBalanceToCustomer || 0,
          invoiceDate:x.invoiceDate,
          invoiceItemList:x.invoiceItemList,
          invoiceBroker:x.invoiceBroker,
          
        };

        return sales.push(sale);
      });
      console.log("sales : ", action.payload);
      state.salesListByCustomerId = sales;
      state.loading = false;
    });
    builder.addCase(fetchAllSalesByCustomerID.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetching sales";
    });
    builder.addCase(sendInvoice.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(sendInvoice.fulfilled, (state, action) => {
      // Add user to the state array

      console.log("sendInvoice ", action)
      if(!action.payload) return alert("email send failed")
      
      state.successMessage = "invoice emailed successfully"
      state.loading = false;
    });
    builder.addCase(sendInvoice.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in sendInvoice";
      console.log(state.errorMessage)
    });
    builder.addCase(updateInvoiceStatus.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateInvoiceStatus.fulfilled, (state, action) => {
      // Add user to the state array

      console.log("update invoice", action)
      if(!action.payload) return alert("update failed")
      let sales = [];
      let x = action.payload 
        let sale = {
          id: x._id,
          invoiceNumber:x.invoiceNumber,
          invoiceCreatedDate:x.invoiceCreatedDate,
          invoiceType:x.invoiceType,
          invoiceCategory:x.invoiceCategory,
          invoiceSubCategory:x.invoiceSubCategory,
          invoiceCurrency:x.invoiceCurrency,
          invoiceShipmentStatus:x.invoiceShipmentStatus,
          invoicePaymentType:x.invoicePaymentType,
          invoiceStatus:x.invoiceStatus,
          invoiceCustomer:x.invoiceCustomer,
          invoiceBanks:x.invoiceBanks,
          invoiceSubTotal:x.invoiceSubTotal,
          invoiceDiscountAmount:x.invoiceDiscountAmount,
          invoiceSubTotalAfterDiscount:x.invoiceSubTotalAfterDiscount,
          invoiceGrandTotal:x.invoiceGrandTotal,
          invoiceExtraCharges:x.invoiceExtraCharges,
          invoiceTotalAmountReceived:x.invoiceTotalAmountReceived,
          invoiceBalanceToReceived:x.invoiceBalanceToReceived,
          invoiceBalanceToCustomer:x.invoiceBalanceToCustomer,
          invoiceDate:x.invoiceDate,
          invoiceItemList:x.invoiceItemList,
          invoiceBroker:x.invoiceBroker,
        };
  
      let allSales = state.sales.filter(x=>x.id !== sale.id)
      allSales.push(sale)
      state.sales = allSales
      state.successMessage = "Invoice Status updated"
      state.loading = false;
    });
    builder.addCase(updateInvoiceStatus.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in update Invoice Status";
    });

    // add all sales
    builder.addCase(addSales.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(addSales.fulfilled, (state, action) => {
      // Add user to the state array
      // let shape = {
      //   id: action.payload._id,
      //   foreignInvoice: action.payload.foreignInvoice,
      //   invoiceType: action.payload.invoiceType,
      //   invoicePaymentType: action.payload.invoicePaymentType, //cash // cheque
      //   invoicePaidType: action.payload.invoicePaidType, //full // partial // installment
      //   invoiceDate: action.payload.invoiceDate,
      //   invoiceNumber: action.payload.invoiceNumber,
      //   invoiceCreatedBy: action.payload.invoiceCreatedBy,

      //   invoiceStatus: action.payload.invoiceStatus,
      //   invoiceCustomer: action.payload.invoiceCustomer,
      //   invoiceItemList: action.payload.invoiceItemList,

      //   invoiceForeignTotalAmount: action.payload.invoiceForeignTotalAmount,
      //   invoicePaidAmount: action.payload.invoicePaidAmount,
      //   invoiceTotalAmount: action.payload.invoiceTotalAmount,
      //   invoiceTotalDiscountAmount: action.payload.invoiceTotalDiscountAmount,
      //   invoiceAdvanceAmount: action.payload.invoiceAdvanceAmount,
      //   invoiceBalanceAmount: action.payload.invoiceBalanceAmount,
      //   invoicePayableTotal: action.payload.invoicePayableTotal,
      // };
      state.sales = [...state.sales, action.payload];
      state.recentAddedInvoice = action.payload;
       state.successMessage = "Invoice Created Successfully"
      state.loading = false;
    });
    builder.addCase(addSales.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding sales";
      console.log(state.errorMessage);
    });

    //update
    builder.addCase(updateSales.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateSales.fulfilled, (state, action) => {
      // Add user to the state array
      let x = action.payload
      let singleData = {
        id: x._id,
        invoiceNumber:x.invoiceNumber,
        invoiceCreatedDate:x.invoiceCreatedDate,
        invoiceType:x.invoiceType,
        invoiceCategory:x.invoiceCategory,
        invoiceSubCategory:x.invoiceSubCategory,
        invoiceCurrency:x.invoiceCurrency,
        invoiceShipmentStatus:x.invoiceShipmentStatus,
        invoicePaymentType:x.invoicePaymentType,
        invoiceStatus:x.invoiceStatus,
        invoiceCustomer:x.invoiceCustomer,
        invoiceBanks:x.invoiceBanks,
        invoiceSubTotal:x.invoiceSubTotal,
        invoiceDiscountAmount:x.invoiceDiscountAmount,
        invoiceSubTotalAfterDiscount:x.invoiceSubTotalAfterDiscount,
        invoiceGrandTotal:x.invoiceGrandTotal,
        invoiceExtraCharges:x.invoiceExtraCharges || 0,
        invoiceTotalAmountReceived:x.invoiceTotalAmountReceived || 0,
        invoiceBalanceToReceived:x.invoiceBalanceToReceived || 0 ,
        invoiceBalanceToCustomer:x.invoiceBalanceToCustomer || 0,
        invoiceDate:x.invoiceDate,
        invoiceItemList:x.invoiceItemList,
        invoiceBroker:x.invoiceBroker,
      }; 

      //remove old one
      let newArr = state.sales.filter(function (e) {
        return e.id !== singleData.id;
      });
      newArr.push(singleData);

      state.sales = newArr;
      state.loading = false;
      state.successMessage= "Invoice Update Successfully"
    });
    builder.addCase(updateSales.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding sales";
      console.log(state.errorMessage);
    });
  },
});
export const {
  clearInvoice,
  addSummary,
  addCartItemDiscount,
  addInvoiceCustomer,
  fullPaid,
  calculateTotalPrice,
  addInvoiceType,
  addTotalInvoiceAmount,
  addToCart,
  removeAllItemFromCart,
  removeItemFromCart,
  addNewSalestoLocal,
  addEditedInvoice,
  removeItemFromEditCart,
  addEditedSalesToLocal,
  addCartEditedInvoiceItemDiscount,
  addToCartEditedInvoice,
  removeAllItemFromCartEditedInvoice,
  clearEditInvoice,
  
} = salesSlice.actions;
export default salesSlice.reducer;
